(function () {
  'use strict';

  var LANG_KEY = window.__SE_LANG_KEY || 'soffexpert_lang';
  var SUPPORTED = { sv: 1, en: 1, da: 1 };
  var ATTRS = ['placeholder', 'aria-label', 'title', 'alt', 'value'];

  function storageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function storageSet(key, val) {
    try { localStorage.setItem(key, val); return true; } catch (e) { return false; }
  }

  /** Force Danish market (DKK) when visiting soffexpert.dk */
  function detectDomainLang() {
    try {
      var host = String(location.hostname || '').replace(/^www\./i, '').toLowerCase();
      if (host === 'soffexpert.dk' || host.endsWith('.soffexpert.dk')) return 'da';
    } catch (e) {}
    return null;
  }

  function p(en, da) {
    return { en: en, da: da };
  }

  var KEYS = {
    'date.today': { sv: 'idag', en: 'today', da: 'i dag' },
    'date.yesterday': { sv: 'igår', en: 'yesterday', da: 'i går' },
    'date.days_ago': { sv: 'för {n} dagar sedan', en: '{n} days ago', da: 'for {n} dage siden' },
    'date.week_ago': { sv: 'för 1 vecka sedan', en: '1 week ago', da: 'for 1 uge siden' },
    'date.weeks_ago': { sv: 'för {n} veckor sedan', en: '{n} weeks ago', da: 'for {n} uger siden' },
    'date.month_ago': { sv: 'för 1 månad sedan', en: '1 month ago', da: 'for 1 måned siden' },
    'date.months_ago': { sv: 'för {n} månader sedan', en: '{n} months ago', da: 'for {n} måneder siden' },
    'date.year_ago': { sv: 'för 1 år sedan', en: '1 year ago', da: 'for 1 år siden' },
    'date.years_ago': { sv: 'för {n} år sedan', en: '{n} years ago', da: 'for {n} år siden' },
    'reviews.verified': { sv: 'Verifierad köpare', en: 'Verified buyer', da: 'Verificeret køber' },
    'reviews.signoff': { sv: 'Med vänliga hälsningar, {name}', en: 'Kind regards, {name}', da: 'Med venlig hilsen, {name}' },
    'reviews.prev_page': { sv: 'Föregående sida', en: 'Previous page', da: 'Forrige side' },
    'reviews.next_page': { sv: 'Nästa sida', en: 'Next page', da: 'Næste side' },
    'reviews.based_on': { sv: 'Baserat på {count} recensioner', en: 'Based on {count} reviews', da: 'Baseret på {count} anmeldelser' },
    'reviews.prev_review': { sv: 'Föregående recension', en: 'Previous review', da: 'Forrige anmeldelse' },
    'reviews.next_review': { sv: 'Nästa recension', en: 'Next review', da: 'Næste anmeldelse' }
  };

  var PHRASES = {
    'Välj språk för att se hela webbplatsen på ditt språk.': p(
      'Choose a language to view the entire website in your language.',
      'Vælg sprog for at se hele websitet på dit sprog.'
    ),
    'Du kan byta språk när som helst via knappen längst ner på sidan.': p(
      'You can change language anytime using the button at the bottom of the page.',
      'Du kan skifte sprog når som helst via knappen nederst på siden.'
    ),
    'VÄLJ SPRÅK': p('CHOOSE LANGUAGE', 'VÆLG SPROG'),
    'Stäng och fortsätt på svenska': p('Close and continue in Swedish', 'Luk og fortsæt på svensk'),
    'Språkval': p('Language selection', 'Sprogvalg'),
    'Byt språk': p('Change language', 'Skift sprog'),

  /* —— Sälj soffa —— */
    'Vad är det för soffa?': p('What kind of sofa is it?', 'Hvilken slags sofa er det?'),
    't.ex. Grå IKEA Kivik, ca 240 cm bred': p('e.g. Grey IKEA Kivik, approx. 240 cm wide', 'f.eks. grå IKEA Kivik, ca. 240 cm bred'),
    'Skick': p('Condition', 'Stand'),
    'Välj skick': p('Select condition', 'Vælg stand'),
    'Bra skick': p('Good condition', 'God stand'),
    'Mycket bra skick': p('Very good condition', 'Meget god stand'),
    'Utmärkt skick': p('Excellent condition', 'Fremragende stand'),
    'Som ny': p('Like new', 'Som ny'),
    'Ny': p('New', 'Ny'),
    'Helt ny': p('Brand new', 'Helt ny'),
    'Mer om skick': p('More about condition', 'Mere om stand'),
    'Mer om behandling': p('More about treatment', 'Mere om behandling'),
    'Stäng': p('Close', 'Luk'),
    'Nyskick': p('Like new', 'Som ny'),
    'Mycket bra': p('Very good', 'Meget god'),
    'Bra – normalt slitage': p('Good – normal wear', 'God – normal slid'),
    'Okej – synligt slitage': p('Fair – visible wear', 'Ok – synlig slid'),
    'Sliten': p('Worn', 'Slidt'),
    'Var finns soffan?': p('Where is the sofa located?', 'Hvor står sofaen?'),
    'Postnummer': p('Postal code', 'Postnummer'),
    'Namn': p('Name', 'Navn'),
    'E-post': p('Email', 'E-mail'),
    'Telefon (valfritt)': p('Phone (optional)', 'Telefon (valgfrit)'),
    '(valfritt)': p('(optional)', '(valgfrit)'),
    '076-000 00 00': p('076-000 00 00', '076-000 00 00'),
    'Bilder': p('Photos', 'Billeder'),
    'Ladda upp filer': p('Upload files', 'Upload filer'),
    'Skicka förfrågan': p('Send request', 'Send forespørgsel'),
    'Vi svarar inom 1–2 arbetsdagar.': p('We reply within 1–2 business days.', 'Vi svarer inden for 1–2 hverdage.'),
    'Sälj din soffa till oss': p('Sell your sofa to us', 'Sælg din sofa til os'),
    'Fyll i uppgifterna nedan – det tar bara en minut.': p(
      'Fill in the details below — it only takes a minute.',
      'Udfyld oplysningerne nedenfor — det tager kun et minut.'
    ),
    'Tack för din förfrågan!': p('Thank you for your request!', 'Tak for din forespørgsel!'),
    'Vi har tagit emot dina uppgifter och bilder. Vi återkommer till dig inom 1–2 arbetsdagar.': p(
      'We have received your details and photos. We will get back to you within 1–2 business days.',
      'Vi har modtaget dine oplysninger og billeder. Vi vender tilbage inden for 1–2 hverdage.'
    ),
    'Kontrollera postnumret': p('Please check the postal code', 'Kontrollér postnummeret'),
    'fil': p('file', 'fil'),
    'filer': p('files', 'filer'),
    'Endast jpg, png, webp och heic.': p('Only jpg, png, webp and heic.', 'Kun jpg, png, webp og heic.'),
    'Varje bild får max vara 5 MB.': p('Each image can be max 5 MB.', 'Hvert billede må maks. være 5 MB.'),
    'Ta bort': p('Remove', 'Fjern'),
    'Beskriv soffan.': p('Describe the sofa.', 'Beskriv sofaen.'),
    'Välj skick.': p('Select condition.', 'Vælg stand.'),
    'Ange postnummer (5 siffror).': p('Enter postal code (5 digits).', 'Angiv postnummer (5 cifre).'),
    'Ange ditt namn.': p('Enter your name.', 'Angiv dit navn.'),
    'Ange en giltig e-post.': p('Enter a valid email.', 'Angiv en gyldig e-mail.'),
    'Ladda upp minst en bild.': p('Upload at least one photo.', 'Upload mindst ét billede.'),
    'Skickar…': p('Sending…', 'Sender…'),
    'Kunde inte förbereda bilderna.': p('Could not prepare the images.', 'Kunne ikke forberede billederne.'),
    'Serverfel': p('Server error', 'Serverfejl'),
    'Försök igen.': p('Please try again.', 'Prøv igen.'),
    'Tog för lång tid. Försök med färre bilder eller vänta en stund.': p(
      'Timed out. Try with fewer images or wait a moment.',
      'Tog for lang tid. Prøv med færre billeder eller vent et øjeblik.'
    ),
    'Kunde inte nå servern.': p('Could not reach the server.', 'Kunne ikke nå serveren.'),

  /* —— Kassa —— */
    '← Tillbaka till varukorgen': p('← Back to cart', '← Tilbage til kurven'),
    'SÄKER CHECKOUT': p('SECURE CHECKOUT', 'SIKKER CHECKOUT'),
    'Laddar kassan...': p('Loading checkout...', 'Indlæser kassen...'),
    'Stripe publishable key saknas.': p('Stripe publishable key is missing.', 'Stripe publishable key mangler.'),
    'Kunde inte starta kassan.': p('Could not start checkout.', 'Kunne ikke starte kassen.'),
    'Kassan tog för lång tid. Försök igen.': p('Checkout took too long. Please try again.', 'Kassen tog for lang tid. Prøv igen.'),
    'Bekräftar betalningen...': p('Confirming payment...', 'Bekræfter betalingen...'),
    'Om du har betalat: kontakta oss med din e-post så hjälper vi dig.': p(
      'If you have paid: contact us with your email and we will help you.',
      'Hvis du har betalt: kontakt os med din e-mail, så hjælper vi dig.'
    ),
    'Varukorgen är tom.': p('Your cart is empty.', 'Din kurv er tom.'),
    'Köp med': p('Buy with', 'Køb med'),

  /* —— Tack-sida —— */
    '← Till startsidan': p('← Back to homepage', '← Tilbage til forsiden'),
    'Bearbetar din beställning...': p('Processing your order...', 'Behandler din ordre...'),
    'Ordernummer:': p('Order number:', 'Ordrenummer:'),
    'Något gick fel': p('Something went wrong', 'Noget gik galt'),
    'Tack för din beställning!': p('Thank you for your order!', 'Tak for din bestilling!'),
    'Vi har tagit emot din beställning och skickar en bekräftelse via e-post.': p(
      'We have received your order and will send a confirmation by email.',
      'Vi har modtaget din ordre og sender en bekræftelse via e-mail.'
    ),
    'Fortsätt handla': p('Continue shopping', 'Fortsæt med at handle'),
    'Saknar betalningsreferens. Kontakta oss om du har betalat.': p(
      'Missing payment reference. Contact us if you have paid.',
      'Mangler betalingsreference. Kontakt os hvis du har betalt.'
    ),
    'Kunde inte hämta ordern.': p('Could not fetch the order.', 'Kunne ikke hente ordren.'),
    'Bekräftelse skickad till ': p('Confirmation sent to ', 'Bekræftelse sendt til '),
    'Kunde inte slutföra beställningen.': p('Could not complete the order.', 'Kunne ikke fuldføre ordren.'),

  /* —— Recensioner —— */
    'Så har andras upplevelse varit': p('What others experienced', 'Sådan har andres oplevelse været'),
    'Baserat på 56 recensioner': p('Based on 56 reviews', 'Baseret på 56 anmeldelser'),
    'Fördelning av betyg': p('Rating distribution', 'Fordeling af bedømmelser'),
    '5 stjärnor': p('5 stars', '5 stjerner'),
    '4 stjärnor': p('4 stars', '4 stjerner'),
    '3 stjärnor': p('3 stars', '3 stjerner'),
    '2 stjärnor': p('2 stars', '2 stjerner'),
    '1 stjärnor': p('1 stars', '1 star'),
    'Recensionssidor': p('Review pages', 'Anmeldelsessider'),
    'Föregående recension': p('Previous review', 'Forrige anmeldelse'),
    'Nästa recension': p('Next review', 'Næste anmeldelse'),
    'Föregående': p('Previous', 'Forrige'),
    'Nästa': p('Next', 'Næste'),
    'Föregående sida': p('Previous page', 'Forrige side'),
    'Nästa sida': p('Next page', 'Næste side'),
    'Verifierad köpare': p('Verified buyer', 'Verificeret køber'),
    'Med vänliga hälsningar,': p('Kind regards,', 'Med venlig hilsen,'),

  /* —— Vanligt custom-innehåll —— */
    'Vår rengöringsprocess': p('Our cleaning process', 'Vores rengøringsproces'),
    'Hur fungerar vår inköpsprocess?': p('How does our buying process work?', 'Hvordan fungerer vores indkøbsproces?'),
    'STEG FÖR STEG': p('STEP BY STEP', 'TRIN FOR TRIN'),
    'Vi får in en soffa': p('We receive a sofa', 'Vi modtager en sofa'),
    'Vi börjar rengöra och restaurera': p('We start cleaning and restoring', 'Vi begynder at rengøre og restaurere'),
    'Vi lägger ut soffan till rimligt pris': p('We list the sofa at a fair price', 'Vi sætter sofaen til salg til en fair pris'),
    'Kampanj & favoriter': p('Campaign & favourites', 'Kampagne & favoritter'),
    'Kampanj ': p('Campaign ', 'Kampagne '),
    '& favoriter': p('& favourites', '& favoritter'),
    'Behöver du hjälp?': p('Need help?', 'Brug for hjælp?'),
    'Tillbaka till varukorgen': p('Back to cart', 'Tilbage til kurven'),
    'Till varukorgen': p('To cart', 'Til kurven'),
    'Gå till kassan': p('Go to checkout', 'Gå til kassen'),
    'Betala nu': p('Pay now', 'Betal nu'),
    'Betala senare': p('Pay later', 'Betal senere'),
    'Lägg till önskemål/anteckningar': p('Add requests/notes', 'Tilføj ønsker/noter'),
    'Få först, betala senare': p('Get it first, pay later', 'Få først, betal senere'),
    'eller': p('or', 'eller'),
    'Fortsätt till kassan': p('Continue to checkout', 'Fortsæt til kassen'),
    'Telefon': p('Phone', 'Telefon'),
    'Webbplats': p('Website', 'Hjemmeside'),

  /* —— Relativa datum —— */
    'idag': p('today', 'i dag'),
    'igår': p('yesterday', 'i går'),
    'för 1 vecka sedan': p('1 week ago', 'for 1 uge siden'),
    'för 1 månad sedan': p('1 month ago', 'for 1 måned siden'),
    'för 1 år sedan': p('1 year ago', 'for 1 år siden')
  };

  var PATTERNS = [
    {
      re: /^Baserat på (\d+) recensioner$/,
      en: function (m) { return 'Based on ' + m[1] + ' reviews'; },
      da: function (m) { return 'Baseret på ' + m[1] + ' anmeldelser'; }
    },
    {
      re: /^för (\d+) dagar sedan$/,
      en: function (m) { return m[1] + ' days ago'; },
      da: function (m) { return 'for ' + m[1] + ' dage siden'; }
    },
    {
      re: /^för (\d+) veckor sedan$/,
      en: function (m) { return m[1] + ' weeks ago'; },
      da: function (m) { return 'for ' + m[1] + ' uger siden'; }
    },
    {
      re: /^för (\d+) månader sedan$/,
      en: function (m) { return m[1] + ' months ago'; },
      da: function (m) { return 'for ' + m[1] + ' måneder siden'; }
    },
    {
      re: /^för (\d+) år sedan$/,
      en: function (m) { return m[1] + ' years ago'; },
      da: function (m) { return 'for ' + m[1] + ' år siden'; }
    },
    {
      re: /^(\d+) \/ (\d+)$/,
      en: function (m) { return m[1] + ' / ' + m[2]; },
      da: function (m) { return m[1] + ' / ' + m[2]; }
    }
  ];

  var lang = 'sv';
  var popupEl, fabEl, fabToggleEl, fabMenuEl;
  var fabMenuOpen = false;
  var observer;
  var cookieObserver;
  var apiCache = {};
  var tlMap = { en: 'en', da: 'da' };

  var COOKIE_BANNER_SELECTORS = [
    '#shopify-pc__banner',
    '#shopify-pc-banner',
    '.shopify-pc__prefs__dialog',
    '#CybotCookiebotDialog',
    '#CybotCookiebotDialogBodyUnderlay',
    '#cookie-law-info-bar',
    '#coiOverlay',
    '#pandectes-banner',
    '.cc-window',
    '.cc-banner',
    '.cookie-banner',
    '[class*="cookie-banner"]',
    '[id*="cookie-banner"]',
    '[class*="cookies-prompter"]',
    '[id*="cookies-prompter"]',
    '[class*="consent-banner"]',
    '[id*="consent-banner"]'
  ];

  function shouldAutoTranslate(text) {
    if (!text || text.length < 2) return false;
    if (!/[a-zA-Z\u00C0-\u024F]/.test(text)) return false;
    if (/^https?:\/\//i.test(text)) return false;
    if (/^[\d\s.,:;+\-kr%€$£SEKDKK]+$/i.test(text)) return false;
    return true;
  }

  var NO_TRANSLATE_CLOSEST =
    'script, style, noscript, textarea, code, pre, .se-lang-popup, [data-se-no-translate]';

  function fetchApiTranslation(text, targetLang) {
    var cacheKey = targetLang + '|' + text;
    if (apiCache[cacheKey]) return Promise.resolve(apiCache[cacheKey]);

    var tl = tlMap[targetLang] || 'en';
    var url = 'https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=' + tl + '&dt=t&q=' + encodeURIComponent(text);

    return fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var out = text;
        if (data && data[0]) {
          out = data[0].map(function (part) { return part[0]; }).join('');
        }
        apiCache[cacheKey] = out;
        if (!PHRASES[text]) PHRASES[text] = p(out, out);
        PHRASES[text][targetLang] = out;
        return out;
      })
      .catch(function () { return text; });
  }

  function resolveTranslation(text, targetLang) {
    var immediate = translatePhrase(text, targetLang);
    if (immediate !== text || targetLang === 'sv') return Promise.resolve(immediate);
    if (!shouldAutoTranslate(text)) return Promise.resolve(text);
    return fetchApiTranslation(text, targetLang);
  }

  function localeCodeToLang(code) {
    if (!code) return null;
    code = String(code).toLowerCase().split(/[-_]/)[0];
    if (code === 'da' || code === 'nb' || code === 'no') return 'da';
    if (code === 'en') return 'en';
    if (code === 'sv') return 'sv';
    return null;
  }

  function getLang() {
    if (detectDomainLang() === 'da') return 'da';
    try {
      if (window.Shopify) {
        if (Shopify.country === 'DK' || Shopify.country === 'NO') return 'da';
        var shopifyLang = localeCodeToLang(Shopify.locale);
        if (shopifyLang) return shopifyLang;
      }
      var htmlLang = localeCodeToLang(document.documentElement.lang);
      if (htmlLang) return htmlLang;
    } catch (e) {}
    return lang;
  }

  function applyVars(str, vars) {
    if (!vars) return str;
    return String(str).replace(/\{(\w+)\}/g, function (_, key) {
      return vars[key] != null ? vars[key] : '';
    });
  }

  function translatePhrase(phrase, targetLang) {
    if (!phrase) return phrase;
    targetLang = targetLang || lang;
    if (targetLang === 'sv') return phrase;

    var trimmed = String(phrase).trim();

    var hit = PHRASES[trimmed];
    if (hit && hit[targetLang]) return hit[targetLang];

    for (var i = 0; i < PATTERNS.length; i++) {
      var m = trimmed.match(PATTERNS[i].re);
      if (m) return PATTERNS[i][targetLang](m);
    }
    return phrase;
  }

  function t(phrase, vars) {
    if (KEYS[phrase]) {
      var keyVal = KEYS[phrase][lang] || KEYS[phrase].sv;
      return applyVars(keyVal, vars);
    }
    return applyVars(translatePhrase(phrase, lang), vars);
  }

  function relativeDateFromDays(diff) {
    if (diff <= 0) return t('idag');
    if (diff === 1) return t('igår');
    if (diff < 7) return t('för ' + diff + ' dagar sedan');
    if (diff < 30) {
      var w = Math.floor(diff / 7);
      return w === 1 ? t('för 1 vecka sedan') : t('för ' + w + ' veckor sedan');
    }
    if (diff < 365) {
      var mo = Math.floor(diff / 30);
      return mo === 1 ? t('för 1 månad sedan') : t('för ' + mo + ' månader sedan');
    }
    var y = Math.floor(diff / 365);
    return y === 1 ? t('för 1 år sedan') : t('för ' + y + ' år sedan');
  }

  function shouldSkipNode(node) {
    var p = node.parentElement;
    if (!p) return true;
    return !!p.closest(NO_TRANSLATE_CLOSEST);
  }

  function translateTextNode(node) {
    if (shouldSkipNode(node)) return Promise.resolve();
    if (node.__seOrig == null) node.__seOrig = node.nodeValue;
    var orig = node.__seOrig;
    var lead = orig.match(/^(\s*)/)[1];
    var trail = orig.match(/(\s*)$/)[1];
    var core = orig.trim();

    if (!core) return Promise.resolve();
    if (lang === 'sv') {
      node.nodeValue = orig;
      return Promise.resolve();
    }
    return resolveTranslation(core, lang).then(function (translated) {
      node.nodeValue = lead + translated + trail;
    });
  }

  function translateAttributeEl(el, attr) {
    if (!el.__seAttrOrig) el.__seAttrOrig = {};
    if (el.__seAttrOrig[attr] == null) el.__seAttrOrig[attr] = el.getAttribute(attr);
    var orig = el.__seAttrOrig[attr];
    if (!orig) return Promise.resolve();
    if (lang === 'sv') {
      el.setAttribute(attr, orig);
      return Promise.resolve();
    }
    return resolveTranslation(orig, lang).then(function (translated) {
      el.setAttribute(attr, translated);
    });
  }

  function translateAttributes(root) {
    var scope = root || document.body;
    var jobs = [];
    ATTRS.forEach(function (attr) {
      scope.querySelectorAll('[' + attr + ']').forEach(function (el) {
        if (el.closest(NO_TRANSLATE_CLOSEST)) return;
        jobs.push(translateAttributeEl(el, attr));
      });
    });
    return Promise.all(jobs);
  }

  function translateSelectOptions(root) {
    var scope = root || document.body;
    var jobs = [];
    scope.querySelectorAll('select option').forEach(function (opt) {
      if (!opt.__seOrig) opt.__seOrig = opt.textContent;
      if (lang === 'sv') {
        opt.textContent = opt.__seOrig;
        return;
      }
      jobs.push(resolveTranslation(opt.__seOrig.trim(), lang).then(function (translated) {
        opt.textContent = translated;
      }));
    });
    return Promise.all(jobs);
  }

  function applyDom(root) {
    if (lang === 'sv') {
      restoreDom(root);
      return Promise.resolve();
    }
    var scope = root || document.body;
    var jobs = [];
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) jobs.push(translateTextNode(n));
    return Promise.all(jobs)
      .then(function () { return translateAttributes(scope); })
      .then(function () { return translateSelectOptions(scope); });
  }

  function restoreDom(root) {
    var scope = root || document.body;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) {
      if (n.__seOrig != null) n.nodeValue = n.__seOrig;
    }
    scope.querySelectorAll('*').forEach(function (el) {
      if (el.__seAttrOrig) {
        Object.keys(el.__seAttrOrig).forEach(function (attr) {
          el.setAttribute(attr, el.__seAttrOrig[attr]);
        });
      }
      if (el.tagName === 'OPTION' && el.__seOrig != null) el.textContent = el.__seOrig;
    });
  }

  function updatePopupLead() {
    /* Popup stays in English — data-se-no-translate */
  }

  function isPopupBlocking() {
    return document.documentElement.classList.contains('se-lang-pending') ||
      (popupEl && popupEl.classList.contains('se-lang-popup--open'));
  }

  function suppressCookieBanners() {
    COOKIE_BANNER_SELECTORS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          if (el.closest('.se-lang-popup')) return;
          if (!el.__seCookieSuppressed) {
            el.__seCookieSuppressed = true;
            el.__seCookieStyle = el.getAttribute('style') || '';
          }
          el.style.setProperty('z-index', '1', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          el.style.setProperty('opacity', '0', 'important');
        });
      } catch (e) {}
    });
  }

  function restoreCookieBanners() {
    COOKIE_BANNER_SELECTORS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.__seCookieSuppressed) return;
          if (el.__seCookieStyle) el.setAttribute('style', el.__seCookieStyle);
          else el.removeAttribute('style');
          delete el.__seCookieSuppressed;
          delete el.__seCookieStyle;
        });
      } catch (e) {}
    });
  }

  function watchCookieBanners() {
    if (typeof MutationObserver === 'undefined') return;
    if (cookieObserver) cookieObserver.disconnect();
    cookieObserver = new MutationObserver(function () {
      if (isPopupBlocking()) suppressCookieBanners();
    });
    cookieObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function stopWatchingCookieBanners() {
    if (cookieObserver) {
      cookieObserver.disconnect();
      cookieObserver = null;
    }
  }

  function showPopup() {
    if (!popupEl) return;
    popupEl.classList.add('se-lang-popup--open');
    popupEl.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('se-lang-pending');
    suppressCookieBanners();
    watchCookieBanners();
    updatePopupLead();
  }

  function hidePopup() {
    if (!popupEl) return;
    popupEl.classList.remove('se-lang-popup--open');
    popupEl.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('se-lang-pending');
    stopWatchingCookieBanners();
    restoreCookieBanners();
    if (fabEl) {
      fabEl.classList.add('se-lang-fab--visible');
      updateFabPicker();
      closeFabMenu();
    }
  }

  function closeFabMenu() {
    if (!fabMenuEl || !fabToggleEl) return;
    fabMenuOpen = false;
    fabMenuEl.hidden = true;
    fabToggleEl.setAttribute('aria-expanded', 'false');
  }

  function openFabMenu() {
    if (!fabMenuEl || !fabToggleEl) return;
    fabMenuOpen = true;
    fabMenuEl.hidden = false;
    fabToggleEl.setAttribute('aria-expanded', 'true');
  }

  function toggleFabMenu() {
    if (fabMenuOpen) closeFabMenu();
    else openFabMenu();
  }

  function handleFabOutsideClick(e) {
    if (!fabMenuOpen || !fabEl) return;
    if (fabEl.contains(e.target)) return;
    closeFabMenu();
  }

  function handleFabEscape(e) {
    if (e.key === 'Escape' && fabMenuOpen) closeFabMenu();
  }

  function currentCountry() {
    try {
      var host = String(location.hostname || '').replace(/^www\./i, '').toLowerCase();
      if (host === 'soffexpert.dk' || host.endsWith('.soffexpert.dk')) return 'dk';
      if (host === 'soffexpert.se' || host.endsWith('.soffexpert.se')) return 'se';
    } catch (e) {}
    return 'se';
  }

  function targetOrigin(country) {
    return country === 'dk' ? 'https://soffexpert.dk' : 'https://www.soffexpert.se';
  }

  function switchCountry(country, nextLang) {
    if (country === currentCountry()) {
      setLang(nextLang);
      return;
    }
    try {
      var url = new URL(targetOrigin(country) + location.pathname + location.search + location.hash);
      url.searchParams.set('se_lang', nextLang);
      window.location.href = url.toString();
    } catch (err) {
      window.location.href =
        targetOrigin(country) +
        location.pathname +
        (location.search ? location.search + '&' : '?') +
        'se_lang=' +
        nextLang +
        location.hash;
    }
  }

  function updateFabPicker() {
    if (!fabEl || !fabToggleEl || !fabMenuEl) return;
    var toggleImg = fabToggleEl.querySelector('.se-lang-fab__toggle-img');
    var currentOption = null;

    fabMenuEl.querySelectorAll('.se-lang-fab__option').forEach(function (btn) {
      var btnLang = btn.getAttribute('data-lang');
      var isCurrent = btnLang === lang;
      btn.classList.toggle('is-hidden', isCurrent);
      if (isCurrent) currentOption = btn;
    });

    if (currentOption && toggleImg) {
      var srcImg = currentOption.querySelector('img');
      if (srcImg && srcImg.src) toggleImg.src = srcImg.src;
      var label = currentOption.getAttribute('aria-label') || 'Byt språk';
      fabToggleEl.setAttribute('aria-label', label);
      fabToggleEl.title = label;
    }
  }

  function selectFabOption(btn) {
    var nextLang = btn.getAttribute('data-lang');
    var country = btn.getAttribute('data-se-country');
    closeFabMenu();
    if (country) {
      switchCountry(country, nextLang);
    } else {
      setLang(nextLang);
    }
  }

  function finishLanguageChange(opts) {
    if (window.SoffexpertRegion) window.SoffexpertRegion.refresh();
    applyDom().then(function () {
      updatePopupLead();
      updateFabPicker();
      closeFabMenu();
      if (!opts || !opts.silentPopup) hidePopup();
      document.dispatchEvent(new CustomEvent('soffexpert:langchange', { detail: { lang: lang } }));
    });
  }

  function setLang(next, opts) {
    if (!SUPPORTED[next]) next = 'sv';
    var prev = lang;
    if (prev === next && (!opts || !opts.force)) {
      storageSet(LANG_KEY, lang);
      if (!opts || !opts.silentPopup) hidePopup();
      return;
    }
    lang = next;
    storageSet(LANG_KEY, lang);
    document.documentElement.lang = lang === 'da' ? 'da' : lang === 'en' ? 'en' : 'sv';

    if (window.SoffexpertRegion) {
      window.SoffexpertRegion.applyMarket(next, { skipReload: false }).then(function (status) {
        if (status === 'reloading') {
          hidePopup();
          return;
        }
        finishLanguageChange(opts);
      });
    } else {
      finishLanguageChange(opts);
    }
  }

  function bindPopup() {
    popupEl = document.getElementById('se-lang-popup');
    fabEl = document.getElementById('se-lang-fab');
    if (!popupEl) {
      console.warn('[SoffexpertI18n] Popup saknas — lägg till {% render "soffexpert-language-popup" %} i layout/theme.liquid före </body>.');
      return false;
    }

    popupEl.querySelectorAll('[data-lang]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setLang(btn.getAttribute('data-lang'));
      });
    });

    if (fabEl) {
      fabToggleEl = document.getElementById('se-lang-fab-toggle');
      fabMenuEl = document.getElementById('se-lang-fab-menu');

      if (fabToggleEl) {
        fabToggleEl.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleFabMenu();
        });
      }

      if (fabMenuEl) {
        fabMenuEl.querySelectorAll('.se-lang-fab__option').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            selectFabOption(btn);
          });
        });
      }

      document.addEventListener('click', handleFabOutsideClick);
      document.addEventListener('keydown', handleFabEscape);
    }
    return true;
  }

  function watchDom() {
    if (typeof MutationObserver === 'undefined') return;
    observer = new MutationObserver(function (mutations) {
      if (lang === 'sv') return;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) applyDom(node);
          else if (node.nodeType === 3) translateTextNode(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (!bindPopup()) return;
    var domainLang = detectDomainLang();
    var stored = storageGet(LANG_KEY);
    if (domainLang) {
      stored = domainLang;
      storageSet(LANG_KEY, domainLang);
    }
    if (stored && SUPPORTED[stored]) {
      lang = stored;
      document.documentElement.lang = lang === 'da' ? 'da' : lang === 'en' ? 'en' : 'sv';
      if (window.SoffexpertRegion && window.SoffexpertRegion.needsCountryReload(stored)) {
        window.SoffexpertRegion.applyMarket(stored, { skipReload: false });
        return;
      }
      applyDom().then(function () {
        if (window.SoffexpertRegion) window.SoffexpertRegion.refresh();
        if (fabEl) {
          fabEl.classList.add('se-lang-fab--visible');
          updateFabPicker();
        }
      });
    } else {
      showPopup();
    }
    watchDom();
  }

  window.SoffexpertI18n = {
    getLang: getLang,
    t: t,
    translatePhrase: translatePhrase,
    relativeDateFromDays: relativeDateFromDays,
    setLang: setLang,
    applyDom: applyDom,
    openPopup: function () { showPopup(); },
    addPhrases: function (map) {
      Object.keys(map).forEach(function (key) {
        PHRASES[key] = map[key];
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
